import useSWR from 'swr';
import axiosWithMjrAccessToken from 'utils/axiosWithMjrAccessToken';
import axios from 'axios';

export const useSession = () => {
  const { data, error } = useSWR('/api/auth/session', (url) => axios.get(url).then((res) => res.data));

  return { user: data?.user || null, isLoading: !data && !error };
};

export const useMjrApiUser = () => {
  const { user: session } = useSession();

  if (typeof window === 'undefined') {
    const e = "usemjrapiuser called on server side";
    console.warn(e);
  }

  const url = `${process.env.NEXT_PUBLIC_PROXY_MJR_API_URL}/api/customer/get`;

  return useSWR(
    // if we pass null into the cache key useSWR will not fetch
    // https://swr.vercel.app/docs/conditional-fetching
    () => typeof window !== 'undefined' && session ? `${url}|${session.sub}` : null,
    () => axiosWithMjrAccessToken.get(url).then((res) => res.data)
  );
};

export const useContent = () => useSWR(
  '/api/get-content',
  (url) => axios.get(url).then((res) => res.data),
);
